export default {
  hasSearchedFlag: 'garmin_sc_has_searched_flag',
  lastSearchedTimestamp: 'garmin_sc_last_searched_timestamp',
  productRegistrations: 'garmin_sc_registrations',
  searchFlagExpiration: 1440, // minutes
};
